@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.manage-presets-option {
  color: @fulfillment-planner--presets--text-color;
}
